(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sc-alba-pro"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(event) {
  const link = event.target.closest('[data-alba-type]');
  if (!link) return;
  const root = link.closest('.sc-alba');
  const select = root.querySelector('select[name="contact[Demande]"]');
  const option = Array.from(select.options).find(item => item.dataset.kind === link.dataset.albaType);
  if (option) { select.value = option.value; select.dispatchEvent(new Event('change', { bubbles: true })); }
});

  } catch(e) { console.error(e); }
})();
})();
